import React, { useState, useEffect } from 'react';
import { Button, Box, CardMedia, Typography, TextField, IconButton } from '@mui/material';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import PublishRoundedIcon from '@mui/icons-material/PublishRounded';
import axios from 'axios';
import { refreshUserTokens } from '../tokenHandling';

function Summary({ finalDescription, selectedMockups, mockupResponseData, product }) {
  const [items, setItems] = useState([]);
  
  
  useEffect(() => {
    if (finalDescription && Array.isArray(finalDescription)) {
      const newItems = finalDescription.map(data => ({
        id: data.variant_id,
        image: data.url,
        title: data.title,
        description: data.description,
        variants: data.orientation,
        dalle_image: data.dalle_image,
        price: '50'
      }));
      setItems(newItems);
      console.log(items);
    }
    console.log("CHECK HERE");
    console.log(finalDescription);
    
  }, [finalDescription]);
  

  const handleDelete = (itemId) => {
    setItems(currentItems => currentItems.filter(item => item.id !== itemId));
  };

  const handleEdit = (field, value) => {
    if (items.length > 0) {
      const updatedItems = [...items];
      updatedItems[0] = { ...updatedItems[0], [field]: value };
      setItems(updatedItems);
    }
  };

  const handlePublish = async () => {
    
    try {
      const userToken = await refreshUserTokens();;
      console.log("STARTING:");
      console.log(items);
      console.log(userToken);
      console.log()
      const response = await axios.post(process.env.REACT_APP_PUBLISH_API, {
        data: items,
        key: userToken,
      });
      
      if (response.status === 200) {
        console.log('Data sent successfully');
        window.open('https://www.printful.com/dashboard/store', '_blank');
      } else {
        console.error('Failed to send data to the server');
      }
    } catch (error) {
      console.error('Error sending data to the server:', error);
    } 
  };

  return (
    <Box sx={{
      display: 'flex', // This makes it a flex container
      flexDirection: 'column', // Adjust this as needed (e.g., 'row' for horizontal layout)
      justifyContent: 'center', // Centers content along the main axis (for 'column' this is vertical, for 'row' this is horizontal)
      alignItems: 'center', // Centers content along the cross axis (for 'column' this is horizontal, for 'row' this is vertical)
      width: '100%', // Takes the full width of its parent
      
    }}>
      <Box sx={{
        marginTop:'100px',
        maxWidth: '100%',
        overflowX: 'auto', // Enable horizontal scrolling for the container
        flexDirection: 'row',
        display:'flex',
        gap: '20px',
      }}>
          {items.length > 0 ? items.map((item) => (
            <Box
              key={item.id}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '200px',
                gap: '10px',
                marginBottom: '20px',
                borderRadius: '20px',
                padding: '10px',
                position: 'relative',
                border: '1px solid #f5f5f5',
              }}
            >
              <IconButton onClick={() => handleDelete(item.id)} sx={{ position: 'absolute', right: 8, top: 8 }}>
                <ClearRoundedIcon />
              </IconButton>
              <CardMedia
                component="img"
                sx={{ width: '100%', height: '200px', borderRadius: '10px' }}
                image={item.image}
                alt="Product Image"
              />
              {/* You can add more item details here if necessary */}
            </Box>
          )) : (
            <Typography>No items to display</Typography>
          )}
      </Box>

      {items.length > 0 && (
        <Box sx={{
          position: 'fixed',
          bottom: '50px',
          left: `calc(50% + 120px)`, // Center horizontally considering the sidebar
          transform: 'translateX(-50%)', // Adjust only horizontally
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          width: '60%', // Adjust the width as needed
          justifyContent: 'center',
          alignItems: 'center',
          gap: '20px',
          borderRadius: '20px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          backgroundColor: 'white',
      }}>
      
      
          <Box sx={{ width: '100%', display: 'flex', gap: '20px' }}> {/* Container for title and price */}
            <TextField
              label="Title"
              size='small'
              variant="outlined"
              value={items[0].title}
              onChange={(e) => handleEdit('title', e.target.value)}
              sx={{ flexGrow: 1, '& .MuiOutlinedInput-root': { backgroundColor: '#F5F5F5', '& fieldset': { borderColor: 'transparent', }, '&:hover fieldset': { borderColor: 'transparent', }, '&.Mui-focused fieldset': { borderColor: 'transparent', }, }, }}
            />
            <TextField
              label="Price"
              size='small'
              variant="outlined"
              value={items[0].price}
              onChange={(e) => handleEdit('price', e.target.value)}
              sx={{ width: '400px', '& .MuiOutlinedInput-root': { backgroundColor: '#F5F5F5', '& fieldset': { borderColor: 'transparent', }, '&:hover fieldset': { borderColor: 'transparent', }, '&.Mui-focused fieldset': { borderColor: 'transparent', }, }, }}
            />
          </Box>
          <TextField
            label="Description"
            variant="outlined"
            size='small'
            value={items[0].description}
            onChange={(e) => handleEdit('description', e.target.value)}
            fullWidth
            multiline
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#F5F5F5',
                '& fieldset': {
                  borderColor: 'transparent',
                },
                '&:hover fieldset': {
                  borderColor: 'transparent',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'transparent',
                },
              },
            }}
          />
          <Button
            onClick={handlePublish}
            sx={{
              bgcolor: '#ff4c15',
              '&:hover': { bgcolor: '#e2400f' },
              color: 'white',
              mt: 2,
              height: '50px',
              borderRadius: '10px',
            }}
            variant="contained"
            fullWidth
            startIcon={<PublishRoundedIcon />}
          >
            Publish
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default Summary;
